import { render, staticRenderFns } from "./WorkflowPrepTaskEdit.vue?vue&type=template&id=b5f8cecc"
import script from "./WorkflowPrepTaskEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepTaskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports